import * as React from "react";
import { CSSProperties } from "react";

interface LogoProps {
	style?: CSSProperties;
	isHeader?: boolean;
}

export default ({ style, isHeader }: LogoProps) => (
	<img
		src={
			isHeader ? 
			require("../res/new_logo.svg").default :
			require("../res/new_logo_white.svg").default}
		style={style}
	/>
);
